/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportNoShowBody
 */
export interface ReportNoShowBody {
    /**
     * Team ID of the team being reported as no-show
     * @type {string}
     * @memberof ReportNoShowBody
     */
    noShowTeamId: string;
    /**
     * Optional evidence URLs (screenshots, etc.)
     * @type {Array<string>}
     * @memberof ReportNoShowBody
     */
    evidence?: Array<string>;
}

/**
 * Check if a given object implements the ReportNoShowBody interface.
 */
export function instanceOfReportNoShowBody(value: object): value is ReportNoShowBody {
    if (!('noShowTeamId' in value) || value['noShowTeamId'] === undefined) return false;
    return true;
}

export function ReportNoShowBodyFromJSON(json: any): ReportNoShowBody {
    return ReportNoShowBodyFromJSONTyped(json, false);
}

export function ReportNoShowBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportNoShowBody {
    if (json == null) {
        return json;
    }
    return {
        
        'noShowTeamId': json['noShowTeamId'],
        'evidence': json['evidence'] == null ? undefined : json['evidence'],
    };
}

export function ReportNoShowBodyToJSON(json: any): ReportNoShowBody {
    return ReportNoShowBodyToJSONTyped(json, false);
}

export function ReportNoShowBodyToJSONTyped(value?: ReportNoShowBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'noShowTeamId': value['noShowTeamId'],
        'evidence': value['evidence'],
    };
}

